import { OrderDirection } from '@app-types/enums/order-direction';
import { UserMailAccountContract } from '@app-types/api/user-mail-account';

export type SortTextField<T> = keyof T | ((item: T) => string);

export function sortByTextField<T>(
  items: readonly T[],
  field: SortTextField<T>
): T[] {
  const getText =
    typeof field === 'function'
      ? field
      : (item: T) => String(item[field] ?? '');

  return [...items].sort((a, b) =>
    getText(a).localeCompare(getText(b), undefined, { sensitivity: 'base' })
  );
}

export const sortByEmailAlias = (
  data: UserMailAccountContract[],
  orderDirection: OrderDirection
) =>
  orderDirection === OrderDirection.Ascending
    ? data.sort((a, b) =>
        (a.mailAccountName || a.mailAccountEmail || '').localeCompare(
          b.mailAccountName || b.mailAccountEmail || ''
        )
      )
    : data.sort((a, b) =>
        (b.mailAccountName || b.mailAccountEmail || '').localeCompare(
          a.mailAccountName || a.mailAccountEmail || ''
        )
      );

export const sortByDate = (
  data: any[],
  fieldName: string,
  orderDirection: OrderDirection
) =>
  data.sort((a, b) => {
    const dateA = a?.[fieldName] ? new Date(a[fieldName]).getTime() : 0;
    const dateB = b?.[fieldName] ? new Date(b[fieldName]).getTime() : 0;

    return orderDirection === OrderDirection.Ascending
      ? dateA - dateB
      : dateB - dateA;
  });
